import React from 'react';
import { img_path } from '../../../environment'

interface Image {
  className?: string;
  src: string;
  alt?: string;
  height?: number;
  width?: number;
  id?:string;
}

const ImageWithBasePath = (props: Image) => {
  // Combine the base path and the provided src to create the full image source URL.
  // Leave absolute URLs (e.g. API-hosted icons/images) untouched; only normalize local paths.
  const isAbsolute = !props.src || /^([a-z][a-z0-9+.-]*:)?\/\//i.test(props.src);
  const normalizedSrc = isAbsolute || props.src.startsWith('/') ? props.src : `/${props.src}`;
  const fullSrc = isAbsolute ? normalizedSrc : `${img_path}${normalizedSrc}`;
  return (
    <img
      className={props.className}
      src={fullSrc}
      height={props.height}
      alt={props.alt}
      width={props.width}
      id={props.id}
    />
  );
};

export default ImageWithBasePath;
